<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0262 20.0247C19.9237 20.1278 19.8018 20.2096 19.6676 20.2654L19.5332 19.9423L19.6676 20.2654C19.5334 20.3213 19.3895 20.35 19.2441 20.35C19.0987 20.35 18.9548 20.3213 18.8206 20.2654L18.9495 19.9556L18.8206 20.2654C18.6865 20.2097 18.5647 20.1279 18.4622 20.0249C18.4622 20.0249 18.4621 20.0248 18.462 20.0247L11.995 13.5577L5.52719 20.0255L5.52289 20.0298L5.52286 20.0297C5.31443 20.231 5.03527 20.3424 4.74552 20.3399C4.45576 20.3374 4.17858 20.2212 3.97368 20.0163C3.76878 19.8114 3.65256 19.5342 3.65004 19.2444C3.64752 18.9547 3.75891 18.6755 3.96022 18.4671L3.96445 18.4627L3.96448 18.4627L10.4323 11.995L3.96448 5.52719L3.96018 5.52289L3.96022 5.52286C3.75891 5.31443 3.64752 5.03527 3.65004 4.74552C3.65256 4.45576 3.76878 4.17858 3.97368 3.97368C4.17858 3.76878 4.45576 3.65256 4.74552 3.65004C5.03527 3.64752 5.31443 3.75891 5.52286 3.96022L5.52723 3.96445L5.52719 3.96448L11.995 10.4323L18.4627 3.96448L18.467 3.96018L18.4671 3.96022C18.6755 3.75891 18.9547 3.64752 19.2444 3.65004C19.5342 3.65256 19.8114 3.76878 20.0163 3.97368C20.2212 4.17858 20.3374 4.45576 20.3399 4.74552C20.3424 5.03527 20.231 5.31443 20.0297 5.52286L20.0255 5.52723L20.0255 5.52719L13.5577 11.995L20.0255 18.4627L20.0255 18.4628C20.2327 18.67 20.3491 18.9511 20.3491 19.2441C20.3491 19.5368 20.2329 19.8176 20.0262 20.0247ZM20.0262 20.0247C20.0259 20.025 20.0257 20.0252 20.0255 20.0254L19.778 19.778L20.0262 20.0247Z"
      fill="#8D5185"
      stroke="#8D5185"
      stroke-width="0.7"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
  },
};
</script>

<style lang="scss" scoped></style>
